// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tbNu","content":"styles_content__JpFD_"};